"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreButton = _interopRequireDefault(require("@vfuk/core-button"));
var _coreIcon = _interopRequireDefault(require("@vfuk/core-icon"));
var _coreParagraph = _interopRequireDefault(require("@vfuk/core-paragraph"));
var _coreHeading = _interopRequireDefault(require("@vfuk/core-heading"));
var _coreBaseProps = require("@vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/BannerBody.style"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BannerBody = function BannerBody(_ref) {
  var _ref$justify = _ref.justify,
    justify = _ref$justify === void 0 ? 'center' : _ref$justify,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse,
    heading = _ref.heading,
    text = _ref.text,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    footnote = _ref.footnote,
    id = _ref.id,
    dataSelectorPrefix = _ref.dataSelectorPrefix,
    dataAttributes = _ref.dataAttributes;
  var componentName = 'BannerBody';
  return /*#__PURE__*/_react["default"].createElement(Styled.BannerBody, _extends({
    justify: justify,
    inverse: inverse,
    id: id,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    "data-component-name": componentName
  }, dataAttributes), /*#__PURE__*/_react["default"].createElement(Styled.BannerContent, null, /*#__PURE__*/_react["default"].createElement(_coreHeading["default"], {
    level: heading.level,
    text: heading.text,
    weight: heading.weight,
    inverse: inverse,
    size: 3,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'heading')
  }), text ? /*#__PURE__*/_react["default"].createElement(_coreParagraph["default"], {
    inverse: inverse,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'paragraph')
  }, text) : null), primaryButton !== null && primaryButton !== void 0 && primaryButton.text || secondaryButton !== null && secondaryButton !== void 0 && secondaryButton.text ? /*#__PURE__*/_react["default"].createElement(Styled.BannerButtons, {
    justify: justify
  }, primaryButton !== null && primaryButton !== void 0 && primaryButton.text ? /*#__PURE__*/_react["default"].createElement(_coreButton["default"], {
    text: primaryButton.text,
    onMouseDown: primaryButton.onMouseDown,
    onMouseUp: primaryButton.onMouseUp,
    onTouchStart: primaryButton.onTouchStart,
    onTouchEnd: primaryButton.onTouchEnd,
    href: primaryButton.href,
    onClick: primaryButton.onClick,
    appearance: primaryButton.appearance,
    inverse: primaryButton.inverse,
    htmlAttributes: primaryButton.htmlAttributes,
    dataAttributes: primaryButton.dataAttributes,
    customRouterProps: primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.customRouterProps,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'primary-button')
  }) : null, secondaryButton !== null && secondaryButton !== void 0 && secondaryButton.text ? /*#__PURE__*/_react["default"].createElement(_coreButton["default"], {
    text: secondaryButton.text,
    onMouseDown: secondaryButton.onMouseDown,
    onMouseUp: secondaryButton.onMouseUp,
    onTouchStart: secondaryButton.onTouchStart,
    onTouchEnd: secondaryButton.onTouchEnd,
    href: secondaryButton.href,
    onClick: secondaryButton.onClick,
    appearance: secondaryButton.appearance,
    inverse: secondaryButton.inverse,
    htmlAttributes: secondaryButton.htmlAttributes,
    dataAttributes: secondaryButton.dataAttributes,
    customRouterProps: secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.customRouterProps,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'secondary-button')
  }) : null) : null, footnote ? /*#__PURE__*/_react["default"].createElement(Styled.BannerFootnote, null, footnote.icon && footnote.icon.name ? /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
    name: footnote.icon.name,
    appearance: footnote.icon.appearance,
    inverse: footnote.icon.inverse,
    size: 5,
    group: footnote.icon.group,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, footnote.icon.name)
  }) : null, /*#__PURE__*/_react["default"].createElement(_coreParagraph["default"], {
    size: 1,
    inverse: inverse,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'footnote-paragraph')
  }, footnote.text)) : null);
};
BannerBody.displayName = "BannerBody";
var _default = BannerBody;
exports["default"] = _default;